import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Stripboard } from '../../../app/entities/stripboard';
import { BaseBlock } from './styled-strips';
import { AddStripMenu } from './add-strip-menu';
import { HeaderData } from './shot-strip.mobile';
import { CellContent, CellLabel } from '../../shootingdays/components/styled-mobile-table';
import { getRenderedTime } from '../../../lib/utils/Convertor';
import { minutesFormatter } from '../../../lib/time-formatters';

import type { BannerStrip } from '../../../app/entities/strip';
import type { Property } from '../../../app/entities/property';

interface MobileBreakStripProps {
  strip: BannerStrip;
  stripboard: Stripboard;
  properties?: Property[];
}

export const MobileBreakStrip: React.FC<MobileBreakStripProps> = observer(
  ({ stripboard, strip, properties }) => {
    const showEstTime = properties?.some((property) => property.key === 'estimatedTime');
    const showTime = properties?.some((property) => property.key === 'startTime');

    return (
      <Container>
        <Block>
          <BlockText>{strip.data.text}</BlockText>
        </Block>

        <HeaderDataWrapper>
          {showTime && (
            <HeaderData>
              <CellLabel>Time</CellLabel>

              <CellContent>{getRenderedTime(strip.startTime)}</CellContent>
            </HeaderData>
          )}

          {showEstTime && (
            <HeaderData>
              <CellLabel>Est. Time</CellLabel>

              <CellContent>{minutesFormatter(strip.data.estimatedTime || 0)}</CellContent>
            </HeaderData>
          )}
        </HeaderDataWrapper>

        <AddStripMenu
          stripId={strip._id}
          projectId={stripboard.projectId}
          position={strip.position}
          isDark
          stripType="banner"
        />
      </Container>
    );
  },
);

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  border-radius: 0.4rem;
  background-color: var(--color-grayscale-tuna);
`;

const Block = styled(BaseBlock)`
  min-width: 12rem;
  width: 12rem;
`;

const BlockText = styled.span`
  flex: 0 0 auto;
  font-weight: 400;
  font-size: 1.2rem;
  padding: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

const HeaderDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.4rem;
  width: 100%;
  padding-inline-start: 0.4rem;
`;
